export default __webpack_public_path__ + "static/media/primProduct.fe2db6c7.webp";